const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

/**
 * A country's full name from its code, e.g. 'NZ' → 'New Zealand'. Broker groups store the
 * code. A stored value that isn't a valid code comes back as it is.
 */
export const getCountryName = (code) => {
	try {
		return regionNames.of(code);
	} catch {
		return code;
	}
};
